/* Sort-by custom dropdown — progressively enhances the collection sort <select>
   into a panel that matches the facet filter dropdowns (.facets__display look),
   instead of the OS-drawn native popup that has the "cutoff" look. The native
   <select> is kept (hidden) in the form so its value still submits, and is
   driven on selection so the existing facet AJAX runs unchanged. Re-enhances
   after that AJAX replaces the .sorting markup. Fails safe: if anything throws,
   the native select is left visible and fully functional. */
(function () {
  var CARET =
    '<svg class="icon icon-caret sort-dropdown__caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708z" fill="currentColor"/></svg>';

  function closeAll(except) {
    document.querySelectorAll('.sort-dropdown--open').forEach(function (d) {
      if (d === except) return;
      d.classList.remove('sort-dropdown--open');
      var b = d.querySelector('.sort-dropdown__button');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  var uid = 0;
  function buildOption(opt) {
    var li = document.createElement('li');
    li.className = 'sort-dropdown__item';
    li.setAttribute('role', 'none'); // so the option buttons are direct listbox children semantically
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sort-dropdown__option' + (opt.selected ? ' is-selected' : '');
    b.setAttribute('role', 'option');
    b.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
    b.dataset.value = opt.value;
    b.textContent = opt.text;
    li.appendChild(b);
    return li;
  }

  function enhance(select) {
    var selectWrap = null;
    try {
      if (!select || select.dataset.sortEnhanced) return;
      var field = select.closest('.facet-filters__field') || select.parentElement;
      if (!field) return;
      selectWrap = select.closest('.select');
      select.dataset.sortEnhanced = 'true';

      var current = select.options[select.selectedIndex] || select.options[0];

      var wrap = document.createElement('div');
      wrap.className = 'sort-dropdown';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sort-dropdown__button';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="sort-dropdown__value"></span>' + CARET;
      btn.querySelector('.sort-dropdown__value').textContent = current ? current.text : '';

      var panel = document.createElement('div');
      panel.className = 'sort-dropdown__panel facets__display';
      var ul = document.createElement('ul');
      ul.className = 'sort-dropdown__list list-unstyled';
      var listId = 'SortListbox-' + (++uid);
      ul.id = listId;
      ul.setAttribute('role', 'listbox');        // valid listbox: options are direct children (li = role none)
      ul.setAttribute('aria-label', 'Sort by');
      btn.setAttribute('aria-controls', listId);
      Array.prototype.forEach.call(select.options, function (o) { ul.appendChild(buildOption(o)); });
      panel.appendChild(ul);

      wrap.appendChild(btn);
      wrap.appendChild(panel);

      // hide the native select (kept in the form so its value still submits)
      if (selectWrap) selectWrap.style.display = 'none';
      else select.style.display = 'none';
      field.appendChild(wrap);

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !wrap.classList.contains('sort-dropdown--open');
        closeAll(wrap);
        wrap.classList.toggle('sort-dropdown--open', willOpen);
        btn.setAttribute('aria-expanded', String(willOpen));
        if (willOpen) {
          var sel = panel.querySelector('.sort-dropdown__option.is-selected') || panel.querySelector('.sort-dropdown__option');
          if (sel) sel.focus();
        }
      });

      ul.addEventListener('click', function (e) {
        var opt = e.target.closest('.sort-dropdown__option');
        if (!opt) return;
        var val = opt.dataset.value;
        btn.querySelector('.sort-dropdown__value').textContent = opt.textContent;
        panel.querySelectorAll('.sort-dropdown__option').forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        wrap.classList.remove('sort-dropdown--open');
        btn.setAttribute('aria-expanded', 'false');
        if (select.value !== val) {
          select.value = val;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        btn.focus();
      });

      panel.addEventListener('keydown', function (e) {
        var opts = Array.prototype.slice.call(panel.querySelectorAll('.sort-dropdown__option'));
        var idx = opts.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (opts[idx + 1] || opts[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[idx - 1] || opts[opts.length - 1]).focus(); }
        else if (e.key === 'Home') { e.preventDefault(); opts[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); opts[opts.length - 1].focus(); }
        else if (e.key === 'Escape') {
          wrap.classList.remove('sort-dropdown--open');
          btn.setAttribute('aria-expanded', 'false');
          btn.focus();
        }
      });
      btn.addEventListener('keydown', function (e) {
        if ((e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') && !wrap.classList.contains('sort-dropdown--open')) {
          e.preventDefault();
          btn.click();
        }
      });
    } catch (err) {
      // fail safe: leave the native select usable
      if (select) select.dataset.sortEnhanced = '';
      if (selectWrap) selectWrap.style.display = '';
      try { console.error('sort-dropdown: enhance failed', err); } catch (e) {}
    }
  }

  function enhanceAll() {
    document.querySelectorAll('.facet-filters__sort').forEach(enhance);
  }

  // close on outside click / Escape
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.sort-dropdown')) closeAll(null);
  });
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  function init() {
    enhanceAll();
    if (typeof MutationObserver === 'undefined') return;
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      // the facet AJAX replaces .sorting markup → re-enhance the fresh native
      // select. setTimeout (not rAF) so it still fires in a backgrounded tab.
      setTimeout(function () { scheduled = false; enhanceAll(); }, 50);
    });
    // Observe a common ancestor of BOTH the horizontal sort bar (inside
    // .facets-container) and the vertical-layout sort form (#FacetSortForm, which
    // sits outside it) so re-enhancement fires after facet AJAX in either layout.
    var root = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
